export default "__VITE_ASSET__C_gZ0HKA__"